module.exports = __webpack_public_path__ + "img/phone-w.b3387964.svg";